import {useRef} from 'react'
import Zropdown, {
  useZropdown,
  useZropdownElement,
} from '../../common/components/Zropdown.js'
import Icon from '../../common/icons/Icon.js'
import {currentDropdownSelector} from '../../redux/selectors/ui/index.js'
import {useSelector} from '../../store.js'
import {overflowTabsSelector} from './headerSelectors.js'
import className from '../../common/className.js'
import Quantity from '../../common/components/Quantity.js'
import {showEditTopNavModal} from './EditTopNavModal.js'

function Tab({tab, isFocused}) {
  const ref = useRef()

  useZropdownElement({ref, isSelected: isFocused})

  if (tab.hide) {
    return null
  }

  return (
    <li ref={ref} className="list__item list__item--dropdown">
      <div
        className={className`wrap--dropdown-item flex--justify-nowrap label--selectable label--selectable-pt-pb-0 margin-bottom-0 ${{
          'list__link--dropdown-arrow-focus': isFocused,
        }}`}
      >
        <a
          className={className`list__link list__link--dropdown list__link-overflow-nav ${{active: tab.selected}}`}
          title={tab.display}
          href={tab.url}
          key={tab.display}
        >
          <span>{tab.display}</span>
          {!!tab.attention && (
            <span className="main-nav__count margin-left-4">
              <Quantity value={tab.attention} />
            </span>
          )}
        </a>
      </div>
    </li>
  )
}

export default function NavTabOverflow() {
  const dropdown = 'nav_tab_overflow'
  const currentDropdown = useSelector(currentDropdownSelector)
  const overflowTabs = useSelector(overflowTabsSelector)

  const buttonRef = useRef()

  const {form, onConfirm, onUp, onDown} = useZropdown({
    dropdown,
    list: overflowTabs,
    onSelect: (tab) => {
      window.location.hash = tab.url
    },
    closeOnConfirm: true,
  })

  return (
    <div className="wrap--nav-overflow flex align-items-center">
      <div
        className={className`wrap-outer--tag-dropdown-with-filter lh-sm ${{
          open: currentDropdown === dropdown,
        }}`}
        data-dropdown={dropdown}
      >
        <button
          id={dropdown}
          ref={buttonRef}
          className="btn main-nav__link btn--action-nav-overflow"
          type="button"
        >
          <Icon name="meatballs" className="fs-02 lh-0 v-align-base" />
        </button>
        <Zropdown
          dropdown={dropdown}
          parentRef={buttonRef}
          onConfirm={onConfirm}
          onUp={onUp}
          onDown={onDown}
          blurOnOpen
        >
          {form.results.map((tab, index) => (
            <Tab
              key={index}
              tab={tab}
              isFocused={index === form.selectedIndex}
            />
          ))}
          <li className="list__item--dropdown list__item--dropdown-last">
            <button
              className="btn--link list__link list__link--dropdown list__link--configure"
              type="button"
              onClick={() => showEditTopNavModal()}
            >
              Configure Navigation
            </button>
          </li>
        </Zropdown>
      </div>
    </div>
  )
}
